import ProtectedAPIRepository from './ProtectedAPIRepository'
import APIResponseModel from './APIResponseModel'
import Result from './Result'
import MrdDocuments from '../../models/MrdDocuments'
import DocumentMRDRM from '../responsemodel/DocumentMRDRM'
import DocumentMRDDataMapper from '../datamapper/DocumentMRDDataMapper'

export default class DocumentMrdRepository extends ProtectedAPIRepository {
  private dataMapper = new DocumentMRDDataMapper()

 
  getDataMrd = async (ro?: GetMrdDocumentRequestObject) => {
    const response = await this.post<APIResponseModel<DocumentMRDRM>>('/case/listMrdPayment', ro)
  
    if (response instanceof Result.Success) {
      const data:APIResponseModel<DocumentMRDRM> = response.data
  
      if (data.data !== null && Array.isArray(data.data.items)) {
        let receivedData: MrdDocuments[] = [];
        for (let i = 0; i < data.data.items.length; i++) {
          let it = data.data.items[i]
          const doc = this.dataMapper.map(it);
          receivedData.push(doc[0]);
        }
        return new Result.Success({
          totalItemCount: data.data.total_item_count,
          items: receivedData,
        })
        
      }
      
  
      return new Result.Error(0, 'Data is null')
    }
  
    return response
  }


    updateData = async (ro: UpdateDocumentPendencyRM) => {
      const response = await this.post<APIResponseModel<DocumentMRDRM>>('/case/singleMrdPayment', ro)
      if (response instanceof Result.Success) {
        const data: APIResponseModel<DocumentMRDRM> = response.data
        if (data.data !== null) {
          const receivedData = data.data.items[0] ? this.dataMapper.map(data.data.items[0]) : []
          return new Result.Success(receivedData)
        } else {
          return new Result.Error(0, 'Data is null')
        }
      } else {
        return response
      }
    }
  
  
}

export interface GetMrdDocumentRequestObject {
  to: any
  from: any
  user?:any
  search?: string
  limit?: number
  offset?: number
  id?: string
  case_id?: string
  claimNumber?: any
  client_id?: string
  client_name?: string
  investigator_id?: string
  from_date?: string 
  to_date?: string  
  receipt_status?: string
  payment_status?: string
  amount_status?: string
  reinvestigation?: boolean
  pushback?: boolean
}


export interface UpdateDocumentPendencyRM {

  caseId:string
  investigatorId:string

  expenseDetails: {
    _id: string;
    paymentDate: string;
    utrNumber: string;
    paymentStatus:any
  }[];
}
